import {IconButton} from '@molecules';
import {H2} from '@quarks';
import {cn} from '@utils';
import React from 'react';

interface ListHeaderProps {
  title: string;
  action?: () => void;
  className?: string;
}

export const ListHeader: React.FC<ListHeaderProps> = ({title, action, className}) => {
  return (
    <div className={cn(`flex flex-row justify-between items-center`, className)}>
      <H2 className="">{title}</H2>
      {action && (
        <IconButton
          onClick={action}
          size="small"
          iconButton="tertiary"
          icon={'plus'}
        />
      )}
    </div>
  );
};
